import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import UnstyledImage from "./image";

const DividerWrapper = styled.div`
  width: 100%;
  min-height: 820px;
  position: relative;
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    min-height: 620px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    padding: 1rem;
    min-height: 100vh;
  }
`;

const Image = styled(UnstyledImage)`
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  z-index: 0;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    top: 0;
    left: 0;
    right: 0;
  }
`;

const ContentContainer = styled.div`
  max-width: 1240px;
  width: 100%;
  padding: 2.5rem 0;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  background-color: ${({ theme }) => theme.colors.white};
  position: absolute;
  top: 50%;
  left: 50%;
  right: 0;
  transform: translate(-50%, -50%);
  z-index: 1;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    width: 90%;
    display: block;
    padding: 2rem 1rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    position: relative;
    transform: none;
    top: 0;
    left: 0;
    margin: 0 auto;
  }
`;

const ChildDiv = styled.div`
  width: 57%;

  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    width: 100%;
  }
`;

export default function InfoDivider({ imgUrl, imgAlt, image, children }) {
  return (
    <DividerWrapper>
      <Image alt={imgAlt} src={imgUrl} image={image} />
      <ContentContainer>
        <ChildDiv>{children}</ChildDiv>
      </ContentContainer>
    </DividerWrapper>
  );
}

InfoDivider.propTypes = {
  imgUrl: PropTypes.object,
  imgAlt: PropTypes.string,
  image: PropTypes.object,
  children: PropTypes.node,
};
InfoDivider.defaultProps = {
  imgUrl: undefined,
  imgAlt: undefined,
  image: undefined,
  children: undefined,
};
